import { render } from "./app.vue?vue&type=template&id=74fe5054&lang=pug"
import script from "./app.vue?vue&type=script&lang=js"
export * from "./app.vue?vue&type=script&lang=js"

import "./app.vue?vue&type=style&index=0&id=74fe5054&lang=sass"

import exportComponent from "/builds/WebServers/festival/leaderboards/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__